import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["status", "submit"]

  async submit(event) {
    event.preventDefault()

    const form = event.currentTarget
    const submitLabel = this.submitTarget.value

    this.setStatus("", "text-muted")
    this.submitTarget.disabled = true
    this.submitTarget.value = "Sending..."

    try {
      const response = await fetch(form.action, {
        method: form.method,
        headers: {
          "Accept": "application/json",
          "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')?.content || ""
        },
        body: new FormData(form)
      })

      const data = await response.json()
      if (!response.ok) throw new Error(data.error || "Notification could not be sent.")

      this.setStatus(data.message || "Development cable notification sent.", "text-success")
    } catch (error) {
      this.setStatus(error.message, "text-danger")
    } finally {
      this.submitTarget.disabled = false
      this.submitTarget.value = submitLabel
    }
  }

  setStatus(message, className) {
    if (!this.hasStatusTarget) return

    this.statusTarget.textContent = message
    this.statusTarget.className = `small ${className}`
  }
}
